(function () {
    'use strict';

    angular
        .module('app.home')
        .config(configRoutes);

    configRoutes.$inject = ['$stateProvider', 'atAGlanceResolver', 'handicapCardResolver', 'clubRosterResolver', 'favoritePlayersResolver', 'ultimateScorecardResolver', 'badgeListResolver', 'activitiesResolver', 'favoriteCoursesResolver'];
    function configRoutes($stateProvider, atAGlanceResolver, handicapCardResolver,  clubRosterResolver, favoritePlayersResolver, ultimateScorecardResolver, badgeListResolver, activitiesResolver, favoriteCoursesResolver) {

        $stateProvider.state('home.at-a-glance', {
            url: 'at-a-glance',
            component: 'sc3AtAGlance',
            resolve: atAGlanceResolver
        });
        
        $stateProvider.state('home.handicap-card', {
            url: '/handicap-card',
            component: 'sc3HandicapCard',
            resolve: handicapCardResolver
        });

        $stateProvider.state('home.club-roster', {
            url: 'club-roster',
            component: 'sc3ClubRoster',
            resolve: clubRosterResolver
        });

        $stateProvider.state('home.favorite-players', {
            url: 'favorite-players',
            component: 'sc3FavoritePlayers',
            resolve: favoritePlayersResolver
        });

        $stateProvider.state('home.favorite-courses', {
            url: 'favorite-courses',
            component: 'sc3FavoriteCourses',
            resolve: favoriteCoursesResolver
        });

        $stateProvider.state('home.ultimate-scorecard', {
            url: 'ultimate-scorecard',
            component: 'sc3UltimateScorecard',
            resolve: ultimateScorecardResolver
        });

        $stateProvider.state('home.badges', {
            url: 'badges',
            component: 'sc3BadgeList',
            resolve: badgeListResolver
        });

        $stateProvider.state('home.member-benefits', {
            url: 'member-benefits',
            component: 'sc3MemberBenefits'
        });


        $stateProvider.state('home.referral', {
            url: 'referral',
            component: 'sc3Referral'
        });

        $stateProvider.state('home.activities', {
            url: 'activities',
            component: 'sc3Activities',
            resolve: activitiesResolver
        });

        $stateProvider.state('home.request-transfer', {
            url: 'request-transfer',
            component: 'sc3RequestTransfer'
        });
    }
})();